export enum AirPopulationStatus {
  GOOD = 'Good',
  MODERATE = 'Moderate',
  UNHEALTHY_FOR_SENSITIVE = 'Unhealthy for Sensitive Groups',
  UNHEALTHY = 'Unhealthy',
  VERY_UNHEALTHY = 'Very Unhealthy',
  HAZARDOUS = 'Hazardous',
}

export type AirPopulationResultApi = {
  state: string
  key_category: AirPopulationStatus
  category: string
  description: string
  pollution?: {
    ts: string
    aqius: number
  }
  air_quality_min?: number
  air_quality_max?: number
}
export type AirPopulationCardInfoApi = {
  title: string
  description: string
  disclaimer: string
  featured_image: string
}
export type AirPopulationItemResult = {
  province: string
  keyCategory: AirPopulationStatus
  category: string
  description: string
  qualityMin: number | null
  qualityMax: number | null
  currentAqiusValue: number | null
  updatedTime: string | null
}
export type AirPopulationCardInfo = {
  title: string
  description: string
  disclaimer: string
  featuredImage: string
}
